<button
  [ngStyle]="{
    'background-color': color || env['colors']['primary'],
    color: disabled ? '' : textColor || 'white',
    'margin-bottom': '15px',
  }"
  [disabled]="disabled"
  class="form-action-btn"
  [type]="type"
  mat-raised-button
  (click)="handleAction()"
>
  {{ text }}
</button>
